import { ReactElement, useEffect, useState } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { GoForwardButton } from '../../GoForwardButton';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { CartIcon } from '../../../icons/CartIcon';
import Loading from '../../../icons/Loading';
import { ErrorModal } from '../../../Modal/Modal';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { useError } from '../../../../stores/useError';
import { useRouteLoaderData } from 'react-router-dom';
import { useLinkStore } from '../../../../stores/useLinkStore';

export function AceiteForm(): ReactElement {
  const { handleSubmit, goToNextForm } = useHirePlanForm();
  const Iframe = useLinkStore(state => state.data);

  const width = useWindowSizeStore(state => state.width);
  const produtosGDF = [993, 994, 998, 999, 1000];
  const produtosDnit = [1035, 1036, 1037];

  const data: any = useRouteLoaderData('token-servidor');

  const loading = useLoadingStore(state => state.loading);
  const error = useError(state => state.error);
  const title = useError(state => state.title);
  const text = useError(state => state.text);

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(goToNextForm)}
    >
      {error && <ErrorModal open={true} title={title} text={text} />}
      {Iframe ? (
        <>
          <h2 className="text-[2rem] font-semibold text-center text-primary-main notranslate">
            Termo de aceite
          </h2>
          <div
            className="max-[1000px]:flex-col max-[1000px]:items-center min-[748px]:mt-6 min-[748px]:p-6 min-[748px]:pt-4 w-full flex flex-col justify-center mb-8"
            style={{ backgroundColor: '#F5F5F5' }}
          >
            <span
              className="font-bold mb-8"
              style={{ fontSize: '1rem', color: 'red' }}
            >
              A confirmação de sua assinatura do termo de aceite, é obrigatória
              para prosseguir com a contratação do plano odontológico, e pode
              levar alguns minutos para ser processada.
            </span>
            <span
              className="font-bold mb-8"
              style={{ fontSize: '1rem', color: 'red' }}
            >
              Aguarde alguns instantes pela confirmação.
            </span>
            <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
              Atenção
            </h2>
            <span
              className="font-bold mb-8"
              style={{ fontSize: '1rem', color: 'red' }}
            >
              O documento será disponibilizado logo abaixo e pode demorar alguns
              instantes até o seu carregamento completo.
            </span>
          </div>
          <iframe
            src={Iframe}
            className="w-full h-[calc(100vh-200px)]"
            title="Termo de Aceite"
          />
        </>
      ) : produtosGDF.includes(data?.produtoComercial?.id_prodcomerc) ? (
        <>
          <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
            Termo de aceite
          </h2>
          <p className="font-normal mt-1 text-justify mb-8">
            Confirmo minha adesão ao Auxílio Odontológico oferecido pelo Governo
            do Distrito Federal, conforme disposto no Diário Oficial de julho de
            2024 (Lei Nº 7.524 e Decreto Nº 46.102 de agosto de 2024).
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            O plano odontológico é 99% subsidiado para servidores titulares
            estaduais da administração direta, autárquica e fundacional do DF e
            está sendo disponibilizado através da Odontogroup Sistema de Saúde
            Ltda., operadora credenciada.
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            Estou ciente que o plano não possui carência e requer uma
            permanência mínima de 12 meses.E reforço que estou ciente de que os
            meus dados pessoais serão tratados conforme as disposições da Lei
            Geral de Proteção de Dados (LGPD).
          </p>
        </>
      ) : produtosDnit.includes(data?.produtoComercial?.id_prodcomerc) ? (
        <>
          <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
            Termo de aceite
          </h2>
          <p className="font-normal mt-1 text-justify mb-8">
            Confirmo minha adesão ao Auxílio Odontológico oferecido pelo DNIT,
            conforme disposto publicado no EDITAL DE CHAMAMENTO PÚBLICO Nº
            25/2024 - INEXIGIBILIDADE Nº 163/2024. Através da Odontogroup
            Sistema de Saúde Ltda., operadora credenciada.
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            Estou ciente que o plano requer uma permanência mínima de 12 meses.
            E reforço que estou ciente de que os meus dados pessoais serão
            tratados conforme as disposições da Lei Geral de Proteção de Dados
            (LGPD).
          </p>
          <p className="font-normal font-size-sm mt-1 text-justify mb-8">
            Clicando no “Estou de acordo”, aceito os termos da politica de
            privacidade da odontogroup{' '}
            <a
              href="https://odontogroup.com.br/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-primary-main"
            >
              publicado aqui.
            </a>
          </p>
        </>
      ) : (
        <>
          <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
            Termo de aceite
          </h2>
          <p className="font-normal mt-1 text-justify mb-8">
            Confirmo minha adesão ao Auxílio Odontológico oferecido pelo Órgão,
            conforme disposto publicado em EDITAL DE CHAMAMENTO PÚBLICO, através
            da Odontogroup Sistema de Saúde Ltda., operadora credenciada.
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            Estou ciente que o plano requer uma permanência mínima de 12 meses.
            E reforço que estou ciente de que os meus dados pessoais serão
            tratados conforme as disposições da Lei Geral de Proteção de Dados
            (LGPD).
          </p>
          <p className="font-normal font-size-sm mt-1 text-justify mb-8">
            Clicando no “Estou de acordo”, aceito os termos da politica de
            privacidade da odontogroup{' '}
            <a
              href="https://odontogroup.com.br/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-primary-main"
            >
              publicado aqui.
            </a>
          </p>
        </>
      )}
      {!Iframe && (
        <GoForwardButton
          addBackButton
          desktopText={'Continuar'}
          mobileText={'Continuar'}
        />
      )}
    </form>
  );
}
